import type { ExpertLandingPage as ExpertLandingPageProps } from '../../types';

import type { MetaDataContext } from './types';

type Props = {
  data: {
    expertLandingPage: ExpertLandingPageProps;
  };
};

const expertLandingPageMetaTags = (
  { data }: Props,
  { t, linkTo }: MetaDataContext
) => {
  if (!data || !data.expertLandingPage) {
    return {};
  }

  const title = t('meta', 'expert.landing-page-title');
  const description = t('meta', 'expert.landing-page-description');

  const openGraph = [
    { key: 'url', content: linkTo('experts') },
    { key: 'title', content: title },
    { key: 'description', content: description },
    { key: 'type', content: 'website' },
    { key: 'siteName', content: t('meta', 'site.name') },
  ];

  return {
    description,
    title,
    openGraph,
    canonical: linkTo('experts'),
    structuredData: undefined,
  };
};

export default expertLandingPageMetaTags;
